const QUICK_ORDER = {
  RESET: 'QUICK_ORDER/RESET',
  UPDATE: 'QUICK_ORDER/UPDATE',
  TOGGLE_MODAL: 'QUICK_ORDER/TOGGLE_MODAL',
};

export default QUICK_ORDER;
